export default __webpack_public_path__ + "static/experienceImg1-4a14b89525fec767200128c9e678ce45.png";